module.exports = __webpack_public_path__ + "static/img/case1.301b2cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Home/case1.png
// module id = 2uQN
// module chunks = 1